import { createLanding } from "layout/landing/landing";
import { createImagePreview } from "modules/image-preview/image-preview";
import { mountChecklistAlerts } from "./checklist-alerts";
import { initChecklistSidebar } from "./checklist-sidebar";
import { initArticleRating } from "./article-rating";

createLanding();
createImagePreview();
mountChecklistAlerts();
initChecklistSidebar();
initArticleRating();

// Заголовок пункта приходит из ссылки чек-листа через ?title=<текст>.
// pug отдаёт статичный дефолт, JS подменяет H1 и <title> под конкретный пункт.
const title = new URLSearchParams(window.location.search).get("title");

if (title !== null && title.trim() !== "") {
  const heading = document.querySelector<HTMLElement>(".article-header h1");

  if (heading !== null) {
    heading.textContent = title;
  }

  const checklistName = document.querySelector<HTMLElement>(".article-overline")?.textContent?.trim();
  document.title = checklistName ? `${title} — ${checklistName}` : title;
}

// dev-превью: на :3000 все пункты ведут на одну мок-страницу через ?title=, поэтому
// активный пункт и соседей для пред/след вычисляем по ?title из списка сайдбара.
// В прод эти данные приходят из бэка (is-active + prevUrl/nextUrl) — блок вырезается из сборки.
if (import.meta.env.DEV && title !== null) {
  const items = Array.from(
    document.querySelectorAll<HTMLAnchorElement>(".checklist-item[data-id] .checklist-item-text"),
  );

  const index = items.findIndex(
    (link) => new URL(link.href, window.location.origin).searchParams.get("title") === title,
  );

  if (index !== -1) {
    // подсветка активного пункта в сайдбаре
    items[index]?.closest(".checklist-item")?.classList.add("is-active");

    // пред/след в виджете отзыва — на соседние пункты (или скрыть на границе)
    const navButtons = document.querySelectorAll<HTMLAnchorElement>("[data-rating-nav]");
    const prevButton = navButtons[0];
    const nextButton = navButtons[navButtons.length - 1];
    const prevItem = items[index - 1];
    const nextItem = items[index + 1];

    if (prevItem !== undefined) {
      prevButton?.setAttribute("href", prevItem.getAttribute("href") ?? "#");
    } else {
      prevButton?.remove();
    }

    if (nextItem !== undefined) {
      nextButton?.setAttribute("href", nextItem.getAttribute("href") ?? "#");
    } else {
      nextButton?.remove();
    }
  }
}
